import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { makeStyles } from "@material-ui/core/styles"
import AddIcon from "@material-ui/icons/Add"
import DeleteIcon from "@material-ui/icons/Delete"
import { Card } from "@material-ui/core"

import { Grid } from "@ridecell/web-components-material"
import { Ridecell } from "@ridecell/web-sdk"

import useGlobalContext from "../../../utils/customHooks/useGlobalContext"
import messages from "./messages"

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  buttonCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
    width: "200px",
    margin: "5px",
    borderRadius: "4px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  img: {
    height: "200px",
    width: "200px",
  },
  ripple: {
    backgroundPosition: "center",
    transition: "background 0.8s",
    "&:hover": {
      background:
        "#ffffff radial-gradient(circle, transparent 1%, #ffffff 1%) center/15000%",
    },
    "&:active": {
      backgroundColor: "#f2f2f2",
      backgroundSize: "100%",
      transition: "background 0s",
    },
  },
  input: {
    display: "none",
  },
  deleteIcon: {
    color: "red",
    zIndex: "9",
    position: "absolute",
    right: "0.5rem",
    top: "0.5rem",
    border: "white solid 1px",
    borderRadius: "50%",
    background: "white",
    boxShadow:
      "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)",
  },
  cardContainer: {
    display: "flex",
    justifyContent: "center",
  },
  imageContainer: {
    position: "relative",
  },
})

const UploadFile = ({
  buttonText,
  mivDocID,
  handleNext,
  createCustomer,
  uploadedFiles,
  intl: { formatMessage },
  setUploadedFiles,
  ...props
}) => {
  const classes = useStyles()
  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState()

  const {
    state: { customer },
    toggleBackdrop,
  } = useGlobalContext()

  useEffect(() => {
    if (!file) {
      setPreview(undefined)
      return
    }
    const objectUrl = URL.createObjectURL(file)
    setPreview(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [file])

  const handleFileChange = ({ target }, id) => {
    const file = target.files[0]
    /* 
      Removing the target value so that we can upload files 
      with the same file name instead of it being ignored
    */
    // eslint-disable-next-line
    target.value = ""
    setFile(file)
    const fileData = { document_specification_id: id, document_image: file }
    uploadDocument(fileData)
    setUploadedFiles([...uploadedFiles, id])
  }

  const removeSelectedImage = (evt, mivDocID) => {
    evt.preventDefault()
    setFile(null)
    setUploadedFiles(
      uploadedFiles.filter((uploadedFile) => uploadedFile !== mivDocID)
    )
  }

  const uploadDocument = async (file) => {
    try {
      toggleBackdrop(true)

      await Ridecell.uploadDocuments({ customerId: customer.id, data: file })
      toggleBackdrop(false)
    } catch (e) {
      alert(e?.response?.data?.message || formatMessage(messages.error))
    }
  }

  return (
    <Grid
      className={classes.cardContainer}
      item
      xs={12}
      sm={12}
      lg={6}
      md={12}
      xl={6}
    >
      <input
        accept=".jpg, .jpeg"
        className={classes.input}
        id={mivDocID}
        onChange={(evt) => handleFileChange(evt, mivDocID)}
        disabled={file}
        type="file"
      />
      <label htmlFor={mivDocID}>
        <Card className={`${classes.buttonCard} ${classes.ripple}`}>
          {file ? (
            <div className={classes.imageContainer}>
              <img
                alt={formatMessage(messages.documentPreview)}
                className={classes.img}
                src={preview}
              />
              <DeleteIcon
                className={classes.deleteIcon}
                color="secondary"
                onClick={(evt) => removeSelectedImage(evt, mivDocID)}
              />
            </div>
          ) : (
            <span>
              <AddIcon color="secondary" />
              {buttonText.toUpperCase()}
            </span>
          )}
        </Card>
      </label>
    </Grid>
  )
}

export default injectIntl(UploadFile)
